import { FreeBusyType, getFreeBusyItemBarClass } from 'owa-freebusy-style';
import { ShowAsBarBase } from './ShowAsBar.base';
import {
    ShowAsBarProps,
    ShowAsType,
    ShowAsBarStyleProps,
    ShowAsBarStyles,
} from './ShowAsBar.types';
import { styled } from '@fluentui/react/lib/Utilities';

export type { ShowAsBarProps };

/** The default style of ShowAsBar */
export function getStyles(styleProps: Required<ShowAsBarStyleProps>): ShowAsBarStyles {
    const {
        className,
        theme: { palette },
        showAs,
    } = styleProps;
    return {
        root: [
            'ms-ShowAsBar',
            {
                display: 'inline-block',
                boxSizing: 'border-box',
                width: '6px',
                height: '15px',
            },
            showAs == ShowAsType.OutsideWorkingHours && {
                background: palette.neutralLighterAlt,
                borderColor: palette.neutralTertiary,
                borderStyle: 'solid',
                borderWidth: '1px',
            },
            getFreeBusyItemBarClass(
                ShowAsType[showAs] as FreeBusyType,
                false /*include positioning*/
            ),
            className,
        ],
    };
}

/** The default styled version of ShowAsBar */
export const ShowAsBar = styled<ShowAsBarProps, Required<ShowAsBarStyleProps>, ShowAsBarStyles>(
    ShowAsBarBase,
    getStyles
);
